<template>
<div>
  <md-dialog :md-active.sync="_showAddPatientDialog">
    <md-dialog-title>複製紀錄</md-dialog-title>
    <md-dialog-content>
      <md-tabs>
        <md-tab md-label="選擇客戶">
          <div class="md-layout md-gutter">
            <div class="md-layout-item">
              <md-field>
                <label>姓名</label>
                <md-input v-model="name" @input="getPatient"></md-input>
              </md-field>
            </div>
          </div>
          <md-table>
            <md-table-row>
              <md-table-head>姓名</md-table-head>
              <md-table-head>編號</md-table-head>
            </md-table-row>
            <md-table-row v-for="patient in patients" :key="patient.id">
              <md-table-cell>
                <a @click="$emit('addPatient', patient)">
                  {{patient.name}}
                </a>
              </md-table-cell>
              <md-table-cell>
                {{patient.id_alt}}
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-tab>
      </md-tabs>
    </md-dialog-content>
    <md-dialog-actions>
      <md-button class="md-primary" @click="$emit('close')">關閉</md-button>
    </md-dialog-actions>
  </md-dialog>
</div>
</template>

<script>
import axios from 'axios'
import urls from '@/urls'

export default {
  props: ['showAddPatientDialog'],
  data () {
    return {
      patients: [],
      name: null
    }
  },
  components: {
  },
  computed: {
    _showAddPatientDialog: {
      get: function () {
        return this.showAddPatientDialog
      },
      set: function (val) {
        if (!val) {
          this.$emit('close')
        }
      }
    }
  },
  methods: {
    async getPatient (name) {
      let result = await axios.get(urls({route: 'patient'}), {params: {name}})
      this.patients = result.data.data
    },
    importRecord (record) {
      this.$emit('importRecord', record.id)
      this.$emit('closeImportDialog')
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Record/AddPatient.vue